import { createSlice } from '@reduxjs/toolkit';

import type { Tenant } from '../api/tenants';
import type { PayloadAction } from '@reduxjs/toolkit';

interface TenantState {
	tenant: Tenant | null;
	loading: boolean;
	error: string | null;
}

const initialState: TenantState = {
	tenant: null,
	loading: false,
	error: null,
};

const tenantSlice = createSlice({
	name: 'tenant',
	initialState,
	reducers: {
		setTenant: (state, action: PayloadAction<Tenant>) => {
			state.tenant = action.payload;
			state.loading = false;
			state.error = null;
		},
		clearTenant: (state) => {
			state.tenant = null;
			state.loading = false;
			state.error = null;
		},
		setLoading: (state, action: PayloadAction<boolean>) => {
			state.loading = action.payload;
		},
		setError: (state, action: PayloadAction<string>) => {
			state.error = action.payload;
			state.loading = false;
		},
	},
});

export const { setTenant, clearTenant, setLoading, setError } =
	tenantSlice.actions;
export default tenantSlice.reducer;
